import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxPHPMathRoundService } from '@go-modules/services/php-math-round/php-math-round.service';

export const ngxPHPMathRoundModule = angular.module('ngxPHPMathRoundModule', [])
	.factory('ngxPHPMathRoundService', downgradeInjectable(NgxPHPMathRoundService) as any)
	.name;
